export const environment = {
  production: false,
  api: 'https://api-dev-paymentgp.portalpagoscenam.com/api',
  serviceCENAM: 'https://api-dev-paymentgp.portalpagoscenam.com',
  callback: 'https://api-dev-paymentgp.portalpagoscenam.com',
  // T1 ORIGEN ID FINGER PRINT
  t1_orgid_dfp: '1snn5n9w',
  t1_fingerscript_src: 'https://h.online-metrix.net/fp/tags.js',
  cardinal_action: '/V1/Cruise/Collect',
  centinel_domain: 'https://centinelapistag.cardinalcommerce.com',
  microform_src:
    'https://testflex.cybersource.com/microform/bundle/v2/flex-microform.min.js',
  transactionExpirationTime: 11,
  cookieExpirationTime: 12,
  redirectionEntity: 'https://paquetes2.miclaro.com.ni/portal/packages',
  currency: 'GTQ',
};
